import React, { useState } from 'react';
import { Modal, Box, ButtonGroup, Button, Divider, Paper, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';

export default function DeleteApplicationListsModal({ item, onTriggerDelete }) {

    const [open, setOpen] = useState(false);
    

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const title = `Delete ${item.name}`;

    const handleDelete = async () => {
        await deleteList();
        setOpen(false);
        onTriggerDelete(item);
    };
    
    const deleteList = async () => {
        try {            
            const response = await fetch(`${process.env.REACT_APP_API}/appLists/${item.id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',                
                },
            });

            if (!response.ok) {
                toast.error(`HTTP error! status: ${response.status}`);
            } else {
                const json = await response.json();
                if (json.message !== 'Success') {
                    toast.error(json.message);
                }
            }
        } catch (error) {
            toast.error(error);
        } finally {
            
        }
    };

    return (
        <>
            <Button variant="outlined" color="error" size="small" onClick={handleOpen}>
                <DeleteIcon />
            </Button>
            
            <Modal 
                open={open} 
                onClose={handleClose}
                style={{
                    overlay: {
                    backgroundColor: '#080030', // Semi-transparent black
                    },
                    content: {
                    backgroundColor: '#080030',
                    },
                }}
            >
               
                <Box sx={{color: 'white', p: 4}}>
                    <Box
                    component={Paper}
                    elevation={3}
                    sx={{
                        mx: 'auto',
                        width: 400,
                        bgcolor: '#1e1e1e',
                        p: 2,
                    }}
                >
                        <Typography variant="h4" component="h2" color="white">
                            {title}
                        </Typography>

                        <Divider sx={{ width:'100%', color:'grey', borderTop: 1, mt: 1, mb:2 }} />

                        <Box component="form" sx={{ color: 'white'}}>
                            <Typography>
                                Are you sure you would like to delete this application list?
                                <br /><br />
                                This action can not be undone!
                            </Typography>
                            
                            <Divider sx={{ width:'100%', color:'grey', borderTop: 1, mt:4 }} />
                            <ButtonGroup 
                                size="small"
                                variant="contained" 
                                aria-label="Basic button group" 
                                fullWidth
                                sx={{ mt:2 }}
                            >
                        
                                <Button
                                    onClick={handleClose}
                                    variant="contained"
                                    sx={{
                                        bgcolor: '#303F9F',
                                        textTransform: 'none',
                                        alignSelf: 'flex-start',
                                        mt: 1,
                                        '&:hover': {
                                        bgcolor: '#303F9F',
                                        },
                                        '&:disabled': {
                                        bgcolor: 'rgba(255, 255, 255, 0.12)',
                                        },
                                    }}
                                >
                                    {'Cancel '}
                                </Button>

                                <Button
                                    onClick={() => handleDelete()}
                                    variant="contained"
                                    sx={{
                                        bgcolor: '#303F9F',
                                        textTransform: 'none',
                                        alignSelf: 'flex-start',
                                        mt: 1,
                                        ml: 5,
                                        '&:hover': {
                                        bgcolor: '#303F9F',
                                        },
                                        '&:disabled': {
                                        bgcolor: 'rgba(255, 255, 255, 0.12)',
                                        },
                                    }}
                                >
                                    {'Delete'}
                                </Button>
                            </ButtonGroup>
                        </Box>
                    </Box>
                </Box>
                
            </Modal>            
        </>
    );
}

